import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { BiShow } from "react-icons/bi";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import PointsListingModal from "../../../components/Modals/PointsListingModal";
import EditRouteModal from "../../../components/Modals/EditRouteModal";
import { deleteRouteFromList } from "../../../services/myRoute.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import edit_icon from "../../../assets/edit_icon.svg";
// import det_icon from "../../../assets/del_icon.svg";
import UserNotLoggedIn from "../../../components/UserNotLoggedIn/UserNotLoggedIn";
import delete_image from "../../../assets/rafiki.svg";
// import edit_icon from "../../../assets/edit_icon.svg";
import { MdDelete } from "react-icons/md";
import Pagination from "../../../components/Pagination/Pagination";

const TableView = ({
  route,
  fetchUserRoutes,
  pointName,
  setPointName,
  totalCount,
  pageSize,
  setPageSize,
  setCurrentPage,
  isUserLoggedIn,
  currentPage,
}) => {
  const [showEditRouteModal, setShowEditRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [id, setId] = useState("");
  const [routeDate, setRouteDate] = useState(null);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );
  const toggleEditRoute = () => setShowEditRouteModal(!showEditRouteModal);

  const editRoute = (dt) => {
    let istDate;
    if (dt?.routeStartingDate !== null) {
      istDate = moment(`${dt?.routeStartingDate}Z`).tz("Asia/Kolkata");
    } else {
      istDate = null;
    }
    setShowEditRouteModal(true);
    setId(dt?.routeID);
    setRouteName(dt?.routeName);
    setRouteDate(istDate);
  };

  const deleteRoute = async (id, deleteRouteName) => {
    const removed = await swal({
      title: "Are you sure?",
      text: `You are about to delete the ${deleteRouteName} Route. Do you wish to continue?`,
      icon: delete_image,
      buttons: ["No", "Yes"],
    });
    if (removed) {
      try {
        const response = await deleteRouteFromList({
          userName: userName,
          routeID: id,
        });
        if (response && response?.status === 200) {
          swal("Deleted!", "Your route has been deleted!", "success");
          fetchUserRoutes();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Oops.. something went wrong, try again !!!",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    }
  };

  const showStartDate = (dateTime) => {
    let istDate = moment(`${dateTime}Z`).tz("Asia/Kolkata");

    let today = new Date(istDate);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return today;
  };

  const handlePerRowsChange = async (newPageSize, pageSize) => {
    setPageSize(newPageSize);
  };

  const customStyles = {
    tableWrapper: {
      style: { overflowX: "auto" },
    },
    table: {
      style: {
        backgroundColor: "transparent",
        minWidth: "1150px",
      },
    },
    headRow: {
      style: {
        height: "50px",
        borderRadius: "5px",
        borderWidth: "1px",
        border: "1px solid #81818133",
        background: "#F5F5F5",
        marginBottom: "16px",
      },
    },
    headCells: {
      style: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0%",
        color: "#494949",
        textTransform: "none",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    rows: {
      style: {
        height: "97px",
        borderRadius: "3.75px",
        borderWidth: "0.7px",
        border: "0.7px solid #B1AFAD",
        borderBottom: "0.7px solid #B1AFAD !important",
        backgroundColor: "transparent",
        marginBottom: "16px",
      },
      stripedStyle: {
        backgroundColor: "transparent",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0,0,0,0.05)",
        transitionDuration: "0.25s",
        borderRadius: "3.75px",
      },
      cells: {
        style: {
          backgroundColor: "transparent",
          paddingLeft: "0px",
          paddingRight: "0px",
        },
      },
    },
  };

  const columns = [
    {
      name: "Route Name",
      selector: (row) => row?.route_name,
      sortable: true,
      cell: (d) => (
        <Link
          to={`/my-routes-detail/${d?.routeID}/${d?.routeName}`}
          className="link_route"
        >
          {d?.routeName}
        </Link>
      ),
      width: "17%",
      style: { paddingLeft: "25px", paddingRight: "12px", maxWidth: "17%" },
    },
    {
      name: "No. of Points",
      selector: (row) => row?.no_of_points,
      sortable: true,
      cell: (d) => <span className="link_route">{d?.pointCount}</span>,
      width: "17%",
      // style: { paddingLeft: "25px", paddingRight: "12px", maxWidth: "15%" },
    },
    {
      name: "Start Date",
      selector: (row) => row?.start_date,
      sortable: true,
      cell: (d) =>
        d?.routeStartingDate === null ? (
          <span className="link_route">N/A</span>
        ) : (
          <span className="link_route" style={{ color: "#494949" }}>
            {showStartDate(d?.routeStartingDate)}
          </span>
        ),
      width: "17%",
      // style: { paddingLeft: "25px", paddingRight: "12px", maxWidth: "15%" },
    },
    {
      name: "End Date",
      selector: (row) => row?.end_date,
      sortable: true,
      cell: (d) => (
        <span className="link_route" style={{ color: "#494949" }}>
          N/A
        </span>
      ),
      width: "17%",
      // style: { paddingLeft: "25px", paddingRight: "12px", maxWidth: "17%" },
    },
    {
      name: "Actions",
      selector: (row) => row?.actions,
      sortable: true,
      cell: (d) => {
        return (
          <div
            style={{
              display: "flex",
              gap: "30px",
              justifyItems: "center",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Link to="#" className="link_edit" onClick={() => editRoute(d)}>
              <img src={edit_icon} alt="edit" width="20" />
            </Link>
            <Link
              to={`/my-routes-detail/${d?.routeID}/${d?.routeName}`}
              className="link_view"
            >
              Learn More
            </Link>
            <Link
              to="#"
              className="link_delete"
              onClick={() => deleteRoute(d?.routeID, d?.routeName)}
            >
              <MdDelete size={22} />

              {/* <img src={delete_image} alt="delete" /> */}
            </Link>
          </div>
        );
      },
      width: "30%",
      style: { paddingLeft: "15px", maxWidth: "30%" },
    },
  ];

  return (
    <div className="table_view">
      <EditRouteModal
        showEditRouteModal={showEditRouteModal}
        setShowEditRouteModal={setShowEditRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        routeDate={routeDate}
        setRouteDate={setRouteDate}
        pointName={pointName}
        setPointName={setPointName}
        id={id}
        setRouteName={setRouteName}
        toggleEditRoute={toggleEditRoute}
        fetchUserRoutes={fetchUserRoutes}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      {isUserLoggedIn ? (
        <DataTable
          columns={columns}
          data={route}
          customStyles={customStyles}
          // pagination
          // paginationServer
          // paginationTotalRows={totalCount}
          // paginationPerPage={pageSize}
          // paginationRowsPerPageOptions={[10, 20, 50, 100]}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={(currentPage) => setCurrentPage(currentPage)}
        />
      ) : (
        <UserNotLoggedIn />
      )}
      <div style={{ marginTop: "-16px" }}>
        {(totalCount ?? 0) > 0 && (
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </div>
  );
};

export default TableView;
